import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {Caregiver, Patient} from '@drl/shared/models';

import {PatientCaregiver} from '../models';

@Injectable()
export class PatientCGEhrAdapter implements IAdapter<PatientCaregiver> {
  // sonarignore:start
  adaptToModel(resp: any): PatientCaregiver {
    /// sonarignore:end
    const patientCg: PatientCaregiver = new PatientCaregiver();
    patientCg.patient = new Patient();
    patientCg.careGiver = new Caregiver();
    if (resp) {
      patientCg.patient.firstName = resp.firstName;
      patientCg.patient.middleName = resp.middleName;
      patientCg.patient.lastName = resp.lastName;
      patientCg.patient.externalId = resp.patientExtId;
      patientCg.patient.phone = resp.phone;
      patientCg.patient.statusEnum = resp.status;
      patientCg.patient.genderEnum = resp.gender;
      patientCg.patient.icdCode = resp.diagnosisCode;
      patientCg.patient.comorbidity = resp.comorbidities;
      patientCg.patient.dob = resp.dob;
      patientCg.careGiver.firstName = resp.caregiverFirstName;
      patientCg.careGiver.middleName = resp.caregiverMiddleName;
      patientCg.careGiver.lastName = resp.caregiverLastName;
      patientCg.careGiver.relation = resp.caregiverRelation;
      patientCg.careGiver.phone = resp.caregiverPhone;
      patientCg.careGiver.email = resp.caregiverEmail;
      if (resp.caregiverGender) {
        patientCg.careGiver.genderEnum = resp.caregiverGender;
      }
    }
    return patientCg;
  }
  // sonarignore:start
  adaptFromModel(data: any): any {
    return data;
  }
  // sonarignore:end
}
